import React from 'react';
import clsx from 'clsx';
import styles from 'views/Analytics/AnalyticsMockService/Reporting/NoReportDataPlaceholder/NoReportDataPlaceholder.module.css';
import BzmIcon from '../../../../../components/icons/BzmIcon';

interface NoReportDataPlaceholderProps {
  reportName: string;
}

function NoReportDataPlaceholder(props: NoReportDataPlaceholderProps) {
  return (
    <div className={clsx(styles.NoReportDataPlaceholder, 'd-flex justify-content-center align-items-center')}>
      <div className="text-center">
        <BzmIcon variant={'icon-bzm-danger'} size={120} color={'#8F0E0E'}></BzmIcon>
        <div className="p-2 w-100 bd-highlight text-center position-relative" style={{ bottom: 30, maxWidth: '280px' }}>
          <p>No report data for {props.reportName} available in this time range.</p>
        </div>
      </div>
    </div>
  );
}

export default NoReportDataPlaceholder;
